export interface IconProps {
  active: boolean;
  className?: string;
  disabled?: boolean;
  tooltip?: string;
}

export const circleColor = (active: boolean): string =>
  active ? '#ffffff' : '#000f35';
export const strokeColor = (active: boolean): string =>
  active ? '#000000' : '#d8e0ff';
